/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface TOTPVerifyChallenge
 */
export interface TOTPVerifyChallenge {
    /**
     * 
     * @type {string}
     * @memberof TOTPVerifyChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof TOTPVerifyChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof TOTPVerifyChallenge
     */
    authentication_method: FactorMethod;
}



/**
 * Check if a given object implements the TOTPVerifyChallenge interface.
 */
export function instanceOfTOTPVerifyChallenge(value: object): value is TOTPVerifyChallenge {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}

export function TOTPVerifyChallengeFromJSON(json: any): TOTPVerifyChallenge {
    return TOTPVerifyChallengeFromJSONTyped(json, false);
}

export function TOTPVerifyChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPVerifyChallenge {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
    };
}

export function TOTPVerifyChallengeToJSON(json: any): TOTPVerifyChallenge {
    return TOTPVerifyChallengeToJSONTyped(json, false);
}

export function TOTPVerifyChallengeToJSONTyped(value?: TOTPVerifyChallenge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ChallengeTypeToJSON(value['type']),
        'authentication_method': FactorMethodToJSON(value['authentication_method']),
    };
}

